import { AnyAction } from "redux";
import {
  DELETE_CONFIRMATION_DIALOG_NAME,
  getIAMCredentialCredentialsEntityName,
} from "../actions/iam-credentials";
import { createDialogReducer, DIALOG_DEFAULT_STATE } from "./dialog";
import { IDialogState } from "./index";
import { IIAMCredentialMeta } from "api/entities/iam-credentials";

// export interface IApplicationCredentialsState {
//     [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<IAccessCredentialListItem>;
// }

// function getApplicationCredentialsDefaultState(): IApplicationCredentialsState {
//     return {
//         [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE
//     };
// }
// const getDeleteConfirmationReducer = () => createDialogReducer(getApplicationCredentialsEntityName(), DELETE_CONFIRMATION_DIALOG_NAME);

// export function applicationCredentials(state: IApplicationCredentialsState = getApplicationCredentialsDefaultState(),
//                                        action: AnyAction): IApplicationCredentialsState {
//     state = getDeleteConfirmationReducer()(state, action);
//     return state;
// }

export interface IIAMAccessCredentialsState {
  [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<IIAMCredentialMeta>;
}

function getIAMAccessCredentialsDefaultState(): IIAMAccessCredentialsState {
  return {
    [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
  };
}
const getDeleteConfirmationReducer = () =>
  createDialogReducer(
    getIAMCredentialCredentialsEntityName(),
    DELETE_CONFIRMATION_DIALOG_NAME
  );

export function accessCredentials(
  state: IIAMAccessCredentialsState = getIAMAccessCredentialsDefaultState(),
  action: AnyAction
): IIAMAccessCredentialsState {
  state = getDeleteConfirmationReducer()(state, action);
  return state;
}
